var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[(_vm.activeName == 'first')?_c('SaaSServiceBasicList',{ref:"SaaSServiceBasicListRef",attrs:{"storeId":_vm.storeId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }